module.exports = __webpack_public_path__ + "img/paprica_yellow.dad87055.png";